import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import profileFill from '@iconify/icons-eva/person-fill';
import { alpha } from '@mui/material/styles';
import {
    Button,
    Box,
    Divider,
    MenuItem,
    Typography,
    Avatar,
    IconButton,
    Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';

import { MenuPopover } from '../../components';
import { RootState, store } from '../../store';
import { signOut } from '../../services/cognito.service';
import { stopAuthenticatedReplay } from '../../services/sentry-replay.service';
import Zendesk from '../../utils/zendesk';

export default function AccountPopover() {
    const navigate = useNavigate();
    const { authUser } = useSelector((state: RootState) => state.auth);
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

  const MENU_OPTIONS = [
    {
      label: 'My Profile',
      icon: profileFill,
      linkTo: '/profile',
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

    const handleClose = () => {
        setOpen(false);
    };

    const onLogout = async () => {
        store.dispatch.auth.logout();
        Sentry.setUser(null);
        stopAuthenticatedReplay();
        Zendesk.onLogout();
        localStorage.removeItem('dontShowSaveReportDialog');
        localStorage.removeItem('pom-admin-core-persistor');
        navigate('/');
    };

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleOpen}
                sx={{
                    padding: 0,
                    width: 44,
                    height: 44,
                    ...(open && {
                        '&:before': {
                            zIndex: 1,
                            content: "''",
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            position: 'absolute',
                            bgcolor: (theme) =>
                                alpha(theme.palette.grey[900], 0.72),
                        },
                    }),
                }}
            >
                <Avatar src={authUser.email} alt={authUser.email} />
            </IconButton>

            <MenuPopover
                open={open}
                onClose={handleClose}
                anchorEl={anchorRef.current}
                sx={{ width: 220 }}
            >
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography
                        variant="body2"
                        sx={{ color: 'text.secondary' }}
                        noWrap
                    >
                        {authUser?.email}
                    </Typography>
                </Box>

                <Divider sx={{ my: 1 }} />

                {MENU_OPTIONS.map((option) => (
                    <MenuItem
                        key={option.label}
                        component={Link}
                        onClick={() => {
                        navigate(option.linkTo);
                        }}
                        sx={{ typography: 'body2', py: 1, px: 2.5 }}
                    >
                        <Box
                        component={Icon}
                        icon={option.icon}
                        sx={{
                            mr: 2,
                            width: 24,
                            height: 24
                        }}
                    />

                        {option.label}
                    </MenuItem>
                ))}

                <Box sx={{ p: 2, pt: 1.5 }}>
                    <Button
                        onClick={onLogout}
                        fullWidth
                        color="inherit"
                        variant="outlined"
                    >
                        Log Out
                    </Button>
                </Box>
            </MenuPopover>
        </>
    );
}
